import { isChartSettingsV2Enabled, isKPIChartEnhancementsEnabled, } from '@thoughtspot/session-service';
import { isMeasure } from '@thoughtspot/visualization-column-util';
import { first, get, isEmpty } from 'lodash';
import { useMemo } from 'react';
import { getYAxisColumns } from '../../../core/chart-model-utils';
import { HandleNullData, } from '../../../types';
import { getAppropriateCurrentTuple, getAppropriateRefTuple, getKpiColumnProperties, getKpiDisplayProperties, isAggregationEnabledWithValue, isAnalyseChangeCtaEnabled, isComparisionEnabled, isKpiChartTypeTimeseries, isSinglePointKPIEnabledWithOnlyCurrentValue, isSinglePointKPIEnabledWithValue, } from '../kpi-utils';
export function useKpiModel(chartModel) {
    return useMemo(() => {
        var _a, _b;
        const yAxisColumn = first(getYAxisColumns(chartModel));
        const isYAxisColumnMeasure = !!yAxisColumn && isMeasure(yAxisColumn);
        const isCurrentAndPreviousTuplePresentForSinglePointKPI = isSinglePointKPIEnabledWithValue(chartModel);
        const isSinglePointKPIEnabled = isCurrentAndPreviousTuplePresentForSinglePointKPI ||
            isSinglePointKPIEnabledWithOnlyCurrentValue(chartModel);
        const isChartTimeSeries = isKpiChartTypeTimeseries(chartModel);
        const isChartMeasureTimeSeries = (isChartTimeSeries || isSinglePointKPIEnabled) &&
            isYAxisColumnMeasure;
        const isAggregationEnabled = isAggregationEnabledWithValue(chartModel);
        const tupleSelectionConfig = {
            isAggregationEnabled,
            isSinglePointEnabled: isSinglePointKPIEnabled,
        };
        const effectiveRefTuple = getAppropriateRefTuple(chartModel, tupleSelectionConfig);
        const currentRefTuple = getAppropriateCurrentTuple(chartModel, tupleSelectionConfig);
        const showComparison = isChartMeasureTimeSeries && isComparisionEnabled(chartModel);
        const baseAnalyseCTACondition = isChartMeasureTimeSeries &&
            showComparison &&
            isAnalyseChangeCtaEnabled(chartModel);
        const isKPIChartEnhancementFeatureEnabled = isChartSettingsV2Enabled() && isKPIChartEnhancementsEnabled();
        const { showAnalyseChangeCta } = getKpiDisplayProperties(chartModel);
        const showAnalyseCTA = isKPIChartEnhancementFeatureEnabled
            ? baseAnalyseCTACondition && showAnalyseChangeCta
            : baseAnalyseCTACondition;
        const columnDataLite = get(chartModel, 'data.0.columnDataLite', []);
        const kpiData = get(chartModel, 'data.0.kpiData');
        const yAxisColumnData = (_a = columnDataLite.find(colData => colData.columnId === (yAxisColumn === null || yAxisColumn === void 0 ? void 0 : yAxisColumn.id))) !== null && _a !== void 0 ? _a : {};
        const heroDataValue = isEmpty(kpiData)
            ? get(yAxisColumnData, 'dataValue.0')
            : get(currentRefTuple, 'value');
        const isDataTrulyEmpty = heroDataValue == null;
        const isTimeseriesWithEnhancements = isKPIChartEnhancementsEnabled() && isChartTimeSeries;
        const nullDataHandling = isTimeseriesWithEnhancements
            ? (_b = getKpiColumnProperties(chartModel)) === null || _b === void 0 ? void 0 : _b.handleNullData
            : null;
        const shouldDefaultToZero = isTimeseriesWithEnhancements &&
            isDataTrulyEmpty &&
            (nullDataHandling == null ||
                nullDataHandling === HandleNullData.Zero);
        const shouldShowNoDataFound = isDataTrulyEmpty &&
            (nullDataHandling === HandleNullData.NoDataFound ||
                !isChartTimeSeries);
        const effectiveHeroDataValue = shouldDefaultToZero ? 0 : heroDataValue;
        return {
            yAxisColumn,
            isYAxisColumnMeasure,
            isChartTimeSeries,
            isChartMeasureTimeSeries,
            isCurrentAndPreviousTuplePresentForSinglePointKPI,
            isSinglePointKPIEnabled,
            isAggregationEnabled,
            effectiveRefTuple,
            currentRefTuple,
            showComparison,
            showAnalyseCTA,
            heroDataValue,
            effectiveHeroDataValue,
            shouldShowNoDataFound,
        };
    }, [chartModel]);
}
//# sourceMappingURL=use-kpi-model.js.map